import { apiClient } from './api';
import type { EmployeeHierarchyNode } from '@momentum/types';

export const employeeHierarchyService = {
  async getCompanyHierarchy(
    companyId: string
  ): Promise<EmployeeHierarchyNode[]> {
    return (await apiClient.get(`/employees/company/${companyId}/hierarchy`))
      .data;
  },
};
